module.exports = __webpack_public_path__ + "955b7f226b5cf0114cb29019ac8d1093.mp3";